var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "q2d2e1ibpa",
    d: "M7 1h.01c.03 0 .06.003.088.008L7 1c.039 0 .077.004.115.01.059.011.115.03.167.056l.024.013c.02.01.04.022.058.035l.026.02c.017.013.033.027.048.041l.012.011 3.818 3.819.02.02.026.03-.046-.05c.028.028.053.058.076.09l.027.043.02.039c.008.015.015.032.022.05l.012.037c.02.06.03.124.03.19v7.637c0 1.054-.855 1.909-1.91 1.909H1.91C.855 15 0 14.145 0 13.09V2.91C0 1.854.855 1 1.91 1H7zm-.637 1.272H1.909c-.351 0-.636.286-.636.637v10.182c0 .351.285.636.636.636h7.636c.352 0 .637-.285.637-.636L10.18 6.09H7c-.32 0-.584-.235-.63-.541l-.006-.094-.001-3.183zm1.273 7c.352 0 .637.286.637.637 0 .352-.285.636-.637.636H3.818c-.351 0-.636-.284-.636-.636 0-.351.285-.636.636-.636zm0-6.1v1.646h1.645L7.636 3.172z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-378 -247) translate(238 213) translate(140 33)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2B00E3",
    fillRule: "nonzero",
    xlinkHref: "#q2d2e1ibpa"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRead);
export default __webpack_public_path__ + "static/media/icon-read.e61661bdd3f96b98c4e20167a021824f.svg";
export { ForwardRef as ReactComponent };